/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ShowMore from 'react-show-more-v16';
import './panel-hotel.css';
import CityName from '../../../../commons/iataRenderService';

const PanelHotel = (props) => {
  const ArmarImagenes = (imagenes) => {
    let activo;
    let imagen;
    if (imagenes === null || imagenes === undefined) {
      return (
        <div key='1' className='item active'>
          <img
            alt='hotel-default'
            style={{ height: '200px' }}
            key='1'
            src={`${process.env.RAZZLE_URL}/assets/img/hotel-default.jpg`}
            className='img-responsive img-hotel'
          />
        </div>
      );
    }

    if (imagenes.length === 0) {
      return (
        <div key='1' className='item active'>
          <img
            alt='hotel-default'
            style={{ height: '200px' }}
            key='1'
            src={`${process.env.RAZZLE_URL}/assets/img/hotel-default.jpg`}
            className='img-responsive img-hotel'
          />
        </div>
      );
    }
    return imagenes.map((elemento, indice) => {
      activo = indice === 0 ? ' active' : '';
      imagen = elemento.replace('100x70', '320x200');
      return (
        <div key={indice} className={`item ${activo}`}>
          <img
            alt='hotel'
            src={imagen}
            key={indice}
            className='img-responsive img-hotel'
          />
        </div>
      );
    });

  };

  function renderStar(quantity) {
    const stars = [1, 2, 3, 4, 5];

    return stars.map((currentValue) => {
      const className
        = currentValue <= quantity
          ? 'fa fa-star yellow'
          : 'fa fa-star icon-gray';
      return (
        <div className='inline' key={currentValue}>
          <i className={className} aria-hidden='true' />
        </div>
      );
    });
  }

  const marginSinDescripcion = props.hotel.descripcion
    ? { marginTop: '14px' }
    : { marginTop: '5%' };
  return (
    <div className='panel panel-default custom bordeado '>
      <div className='panel-body'>
        <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12'>
          <div className='row'>
            <div
              id={`slider-img-hoteles-${props.indice}`}
              className='slider-img-hoteles carousel slide'
              data-ride='carousel'
              style={{ marginBottom: '0px' }}
            >
              <div className='carousel-inner'>
                {ArmarImagenes(props.hotel.imagenes)}
              </div>

              <a
                className='left carousel-control'
                href={`#slider-img-hoteles-${props.indice}`}
                data-slide='prev'
              >
                <span className='glyphicon glyphicon-chevron-left' />
                <span className='sr-only'>Previous</span>
              </a>
              <a
                className='right carousel-control'
                href={`#slider-img-hoteles-${props.indice}`}
                data-slide='next'
              >
                <span className='glyphicon glyphicon-chevron-right' />
                <span className='sr-only'>Next</span>
              </a>
            </div>
          </div>
        </div>
        <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12'>
          <div className='titulo' style={marginSinDescripcion}>
            {`${props.hotel.nombre}, `}
            <span className='destino'>
              <CityName fullName='true' upperCase='true' code={props.destino !== undefined ? props.destino : ''} />
              {' '}
            </span>
            {' '}
            {renderStar(props.hotel.clase)}
            {' '}
          </div>
          <div className='habitacion'>
            {' '}
            <span className='noches'>
              {props.hotel.noches === 0
                ? ''
                : `${props.hotel.noches} noches`}
            </span>
            {' '}
            {`   ${props.hotel.tipoHabitacion !== null}`
              ? props.hotel.tipoHabitacion
              : ''}
          </div>
          {props.hotel.regimen !== null ? (<div className='regimen'><span>{props.hotel.regimen}</span></div>) : null}

          <div className='descripcion'>
            <ShowMore
              lines={4}
              more='Ver más'
              less='Ver menos'
              anchorClass=''
            >
              {ReactHtmlParser(props.hotel.descripcion)}
            </ShowMore>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelHotel;
